import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';
import { User } from '../lib/auth';

export default function Wallet() {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(0);
  const [recentTransactions, setRecentTransactions] = useState<any[]>([]);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    loadUserData();
    loadRecentTransactions();
  }, [location]);

  const loadUserData = async () => {
    try {
      const userJson = localStorage.getItem('user');
      if (!userJson) return;
      const user: User = JSON.parse(userJson);
      setBalance(user.wallet_balance);
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };

  const loadRecentTransactions = async () => {
    try {
      const userJson = localStorage.getItem('user');
      if (!userJson) return;
      const user: User = JSON.parse(userJson);
      const { data, error } = await supabase
        .from('ponotransactions')
        .select('*')
        .eq('user_id', user.id)
        .order('created_at', { ascending: false })
        .limit(5);
      if (error) throw error;
      setRecentTransactions(data || []);
    } catch (error) {
      console.error('Error loading transactions:', error);
    }
  };

  const handleTopUp = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      toast.error('Please enter a valid amount');
      return;
    }
    setLoading(true);
    try {
      toast.error('Please visit amah-llc.com to add funds to your wallet');
      setAmount('');
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-4xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-6">Wallet Balance</h1>

        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Current Balance</h2>
          <p className="text-4xl font-bold text-indigo-600">${balance.toFixed(2)}</p>
        </div>

        <div className="my-6 flex items-center">
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="px-4 text-gray-500 text-sm">How to Add Money</span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <p className="text-center text-gray-700 mb-6">
            To add Money in your Balance Create an account on <a href="https://amah-llc.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">amah-llc.com</a> to
            connect to the secure payment platform. Add money to your balance, go to <strong>Transfer</strong>, select
            <strong> Erotique </strong>, add the email address you have on erotique to transfer the money to your Erotique account. Return here to see your balance updated.
          </p>
          
          <div className="flex justify-center mb-6">
            <img 
              src="https://kcgdwjmwmfciiiryhagj.supabase.co/storage/v1/object/public/Public//walleterotiquetopup.png"
              alt="Wallet top-up instructions"
              className="max-w-full rounded-lg shadow-md"
            />
          </div>
        </div>

        <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
          <label className="block text-sm font-medium text-gray-700 mb-2">Amount to Top Up</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="block w-full p-2 border rounded-md"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
          <button
            onClick={handleTopUp}
            disabled={loading}
            className="w-full mt-4 bg-green-600 text-white py-3 px-4 rounded-md hover:bg-green-700 focus:outline-none disabled:opacity-50"
          >
            {loading ? 'Processing...' : 'Top Up'}
          </button>
        </div>

        <div className="mt-6 bg-white p-6 rounded-lg shadow-lg">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Recent Transactions</h2>
          {recentTransactions.length === 0 ? (
            <p className="text-gray-500 text-center py-4">No recent transactions</p>
          ) : (
            recentTransactions.map((transaction) => (
              <div key={transaction.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <span className="text-sm font-medium">{transaction.type}</span>
                <span className="text-lg font-semibold">${transaction.amount.toFixed(2)}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}